module.exports = __webpack_public_path__ + "img/conference.8fe24128.png";